import React from 'react';
import { connect } from 'react-redux';

import ThanksImage from 'assets/images/img_thanks.jpg';
import { MODALS } from 'global-constants';
import { withModal, FullScreenModal } from 'shared/components/Modals';

import ForgotPasswordForm from './ForgotPasswordForm';
import styles from './styles.module.scss';

class ForgotPassword extends React.Component {
  render() {
    return (
      <FullScreenModal closeModal={this.props.closeModal}>
        {this.props.emailSent ? (
          <div className={styles.successMessageWrapper}>
            <div className={styles.successMessageContainer}>
              <img
                className={styles.emailSentImg}
                src={ThanksImage}
                alt="email-sent"
              />
              <div className={styles.pageTitle}>An email is on it's way</div>
              <div className={styles.pageDescription}>
                An email has been sent with instructions to reset your password.
              </div>
            </div>
          </div>
        ) : (
          <ForgotPasswordForm closeModal={this.props.closeModal} />
        )}
      </FullScreenModal>
    );
  }
}

const mapStateToProps = state => {
  const { emailSent } = state.forgotPassword;
  return {
    emailSent
  };
};

export default connect(mapStateToProps)(
  withModal(MODALS.FORGOT_PASSWORD)(ForgotPassword)
);
